// ds-typo-ignore-file — mockup simulates report viewer UI, not marketing site DS
"use client"

import { ReportMockupNav } from "./report-mockup-nav"
import { ReportMockupCards } from "./report-mockup-cards"

/**
 * iPhone-framed report mockup for mobile viewports.
 *
 * Portrait aspect (9:19.5) with Dynamic Island, rounded corners, and a fixed
 * screen height whose inner content scrolls vertically. Intentionally ignores
 * the cursor-tooltip explainer system that the iPad variant uses — it's a
 * hover-based feature and not valuable on a touch device where the whole
 * mockup exists as passive visual context.
 */
export function ReportMockupIphone() {
  return (
    <div className="relative mx-auto w-full max-w-[340px]">
      {/* Phone frame — even bezel, metal gradient, layered shadow */}
      <div
        className="relative rounded-[48px] p-[6px]"
        style={{
          background:
            "linear-gradient(180deg, #1e1e1e 0%, #0a0a0a 50%, #1e1e1e 100%)",
          boxShadow: [
            "inset 0 1px 0 rgba(255,255,255,0.08)",
            "inset 0 -1px 0 rgba(0,0,0,0.5)",
            "0 1px 2px rgba(0,0,0,0.05)",
            "0 10px 30px -6px rgba(0,0,0,0.14)",
            "0 40px 80px -24px rgba(0,0,0,0.22)",
          ].join(", "),
        }}
      >
        {/* Screen — matches bezel minus padding */}
        <div
          className="relative overflow-hidden rounded-[42px] bg-white"
          style={{
            aspectRatio: "9 / 19.5",
            boxShadow: "inset 0 0 0 1px rgba(255,255,255,0.04)",
          }}
        >
          {/* Dynamic Island — floats over the top of the screen */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute top-2 left-1/2 z-30 h-6 w-24 -translate-x-1/2 rounded-full bg-black"
          />

          {/* Content cropped to hero view — no scroll (avoids touch-scroll trap
              where gestures get captured by the inner container on mobile).
              Bottom content is clipped by the frame. */}
          <div className="h-full overflow-hidden">
            {/* Status bar spacer — leaves room for Dynamic Island */}
            <div className="h-10" aria-hidden="true" />
            <ReportMockupNav />
            <div className="flex flex-col p-2">
              <ReportMockupCards />
            </div>
          </div>

          {/* Home indicator */}
          <div
            aria-hidden="true"
            className="pointer-events-none absolute bottom-2 left-1/2 z-30 h-[5px] w-[100px] -translate-x-1/2 rounded-full bg-black/80"
          />
        </div>
      </div>
    </div>
  )
}
